/** Fallback copy when `como_funciona` is empty in DB (key = normalized project name). */
const DOCS = {
  'DONGATO.APP': {
    resumen:
      'E-commerce de arena para gatos con carrito, pagos, panel admin y app de mensajeros con rutas en mapa.',
    como_funciona: `1. **Cliente** entra a dongato.app, elige productos y completa el pedido (React + API PHP).
2. **API PHP** en el mismo servidor persiste pedidos en **MySQL** y expone endpoints REST.
3. **Admin** gestiona catálogo, pedidos y mensajeros desde \`/admin\`.
4. **Mensajeros** usan la app móvil/web de rutas (Leaflet) para ver entregas del día.
5. **Monitoreo**: este panel puede vigilar URL/SSL si se configuran monitores del proyecto.`,
  },
  KIVVU: {
    resumen: 'Portero digital: QR, videollamada WebRTC, apertura vía MQTT y apps móviles.',
    como_funciona: `1. Visitante escanea QR → **frontend** kivvu.app inicia flujo de llamada.
2. **API Node (PM2 :4000)** en IA SERVI autentica, gestiona edificios/apartamentos y señalización WebRTC.
3. **Socket.io** coordina timbre y estado de llamada; residente atiende desde app o web.
4. **MariaDB** guarda usuarios, edificios, suscripciones y logs.
5. Integraciones opcionales: MQTT/cerradura, MercadoPago/PayPal para planes.`,
  },
  AIDATABIZ: {
    resumen: 'SaaS de chat con IA para empresas (orgs, planes, Hermes).',
    como_funciona: `1. Usuario se registra en aidatabiz.app y crea o une una organización.
2. **Backend Node (PM2 :4001)** sirve API de chat, planes y administración.
3. **MySQL** almacena usuarios, conversaciones y configuración.
4. Panel admin en \`/app/admin\` gestiona planes y métricas.
5. Puede integrarse con WhatsApp vía Hermes en servidor dedicado.`,
  },
  'CHAT SERVI AIDATABIZ': {
    resumen: 'Mismo producto que AIDATABIZ (nombre legacy en catálogo).',
    como_funciona: 'Ver **AIDATABIZ**: frontend + API Node en IA SERVI (173.212.246.155) con MySQL.',
  },
  'ACTIVITY DASHBOARD': {
    resumen: 'Panel interno Smart: métricas de servidores, proyectos, alertas y dominios.',
    como_funciona: `1. **React** (activity.smartandsafe.com.co) consume API PHP en el mismo host cPanel.
2. **checkserver.sh** en cada servidor reporta carga/RAM/disco a MySQL central (smart012).
3. Crons en Activity sincronizan SSL, URLs, pagos Hetzner/Contabo y alertas.
4. Los operadores revisan proyectos, infra y bitácora desde este dashboard.`,
  },
  'WHATSAPP ESM': {
    resumen: 'Instancia WhatsApp / mensajería para operaciones ESM.',
    como_funciona: `1. Servidor **WhatsApp ESM** (66.94.112.160) ejecuta el conector/API de mensajes.
2. Se enlaza con procesos de logística ESM (API en A1 ESM / apps PHP según integración).
3. Base de datos compartida o réplica según el flujo configurado en ESM.`,
  },
  'SOCCER AIDATASPORTS WEB': {
    resumen: 'Estadísticas, cuotas, predicciones y magazine de fútbol; API FastAPI para simulaciones y usuarios.',
    como_funciona: 'Ver campo como_funciona en BD (proyecto 14) — ingest PHP en 185, API en 173, BD apuestasia en 185.',
  },
  'SOCCER AIDATASPORTS': {
    resumen: 'Igual que Soccer AiDataSports (nombre actualizado en catálogo).',
    como_funciona: 'Front soccer.aidatasports.com + backendapp.aidatasports.com:8002 + MariaDB apuestasia.',
  },
  ESM: {
    resumen: 'Portal y operaciones ESM Logística (ecosistema esmlogistica.com).',
    como_funciona: `1. Sitios y APIs PHP/MySQL en **A1 ESM** (208.87.134.70).
2. Datos principales en **DB ESM** (104.225.217.156).
3. Correo certificado y cPanel en **212** para dominios de correo.`,
  },
};

function norm(name) {
  return String(name || '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, ' ');
}

export function getProyectoDoc(nombre) {
  const key = norm(nombre);
  return DOCS[key] || null;
}

export function getProyectoComoFunciona(proyecto) {
  if (proyecto?.como_funciona?.trim()) return proyecto.como_funciona.trim();
  const doc = getProyectoDoc(proyecto?.nombre);
  return doc?.como_funciona || '';
}

export function getProyectoResumen(proyecto) {
  if (proyecto?.descripcion?.trim()) return proyecto.descripcion.trim();
  const doc = getProyectoDoc(proyecto?.nombre);
  return doc?.resumen || '';
}
